import { DataVersion, NeighboringAlarmsDTO } from '@hakimo-ui/hakimo/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';
dayjs.extend(utc);

export function useSharedAlarmNeighboringAlarms(
  sharedToken: string,
  searchParams: string,
  refetchInterval: number,
  timestamp: string,
  dataVersion?: DataVersion
) {
  const date = dayjs.utc(timestamp);
  const partitionKey = date.format('YYYYMM');
  const url = `/shared/v2/alarm/neighbors?sharedToken=${sharedToken}&${searchParams}&partitionKey=${partitionKey}`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<NeighboringAlarmsDTO>(request, {
    queryKey: [
      'alarm-neighbors',
      'shared',
      sharedToken,
      { searchParams },
      dataVersion,
    ],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
    noAuth: true,
  });
}

export default useSharedAlarmNeighboringAlarms;
